.group {
  margin-top: 10px;
  margin-bottom: 4px;
}
.group .header {
  background-color: rgb(19.7598039216%, 28.1470588235%, 5.9705882353%);
  color: rgb(80.6911764706%, 91.9705882353%, 62.1470588235%);
  height: 32px;
  line-height: 32px;
  display: flex;
  padding-left: 12px;
  flex: 1 auto;
}
.group .header .text {
  margin-left: 4px;
  color: rgb(93.3161764706%, 97.2205882353%, 86.8970588235%);
}
.group .header .folded {
  margin-right: 8px;
  line-height: 32px;
  opacity: 0.5;
}
.group .recent .item {
  background-color: rgb(80.6911764706%, 91.9705882353%, 62.1470588235%);
  cursor: pointer;
  border-top: 1px solid rgb(76.4828431373%, 90.2205882353%, 53.8970588235%);
  height: 44px;
  line-height: 44px;
  padding-left: 12px;
  display: flex;
  flex-flow: row nowrap;
}
.group .recent .item .date {
  opacity: 0.7;
}
.group .recent .item .ingredient {
  padding-left: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */